<template>
	<v-container fluid>
		<v-dialog 
      v-model = "disconnectAppDialog" 
      width="400">
      <v-card v-if = "appToDisconnect" class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title>
          Disconnect {{ appToDisconnect.name }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to disconnect this App?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color = "black"
            outline
            @click="disconnectAppDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "loaders.disconnect"
            color="error"
            @click="disconnectApp()">
            Disconnect
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
		<v-dialog
			v-model="AppsFormDialog"
			width="500"
			@close="appToEdit = null">
			<v-card class="border-radius-standard">
				<v-card-title>
					<h2>{{ appToEdit ? `Edit ${appToEdit.name}` : 'Add WhatsApp App' }}</h2>
				</v-card-title>
				<v-divider />
				<v-card-text style="max-height: 400px; overflow-y: auto;">
					<add-app
						ref="addApp"
						:put="appToEdit"
						@loading="loaders.add = $event"
						@success="handleAddAppSuccess"/>	
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-spacer/>
					<v-btn
					    outline
					    @click="AppsFormDialog = false;">
					    Cancel
					</v-btn>
					<v-btn
						:loading="loaders.add"
					    color="primary"
					    @click="handleAddAppSubmit()">
					    {{ appToEdit ? 'Save' : 'Create' }}
					</v-btn>
				</v-card-actions>
			</v-card>	
		</v-dialog>
		<v-layout row wrap>
			<v-flex xs12>
				<h1>WhatsApp Apps</h1>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="card-curvey">
					<v-layout row wrap>
						<v-spacer />
						<v-btn
							color="blue-grey"
							class="nlp-nav-btn"
							small
							outline
							@click="handleAddAppClick">
							<v-icon>add</v-icon>
							Add App
						</v-btn>
					</v-layout>
					<v-card-text>
						<v-data-table
							:items="smoochApps"
							:headers="headers"
							:loading="loaders.apps">
							<template slot="items" slot-scope = "props">
								<td>{{ props.item.name }}</td>
								<td>{{ props.item.phone_number }}</td>
								<td class="actions-col">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												v-on="on"
												:disabled="loaders.disconnect"
												class="px-3 campaigns-small-actions-btn"
												@click="handleEditApp(props.item)">
												<v-icon class="px-3 campaigns-small-actions-btn">
													edit
												</v-icon>
											</v-btn>
										</template>
										<span>Edit</span>
									</v-tooltip>
									<v-tooltip v-if="props.item.status !== 'disconnected'" bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												v-on="on"
												:disabled="loaders.disconnect"
												class="px-3 campaigns-small-actions-btn"
												@click="handleDisconnectAppClick(props.item)">
												<v-icon class="px-3 campaigns-small-actions-btn">
													electrical_services
												</v-icon>
											</v-btn>
										</template>
										Disconnect
									</v-tooltip>
									<v-tooltip v-else bottom>
										<template v-slot:activator="{ on }">
											<v-btn
												v-on="on"
												:disabled="loaders.disconnect"
												class="px-3 campaigns-small-actions-btn"
												@click="connectApp(props.item)">
												<v-icon class="px-3 campaigns-small-actions-btn">
													bolt
												</v-icon>
											</v-btn>
										</template>
										Connect
									</v-tooltip>
								</td>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-flex>
	</v-layout>
	</v-container>
</template>

<script>
import AddApp from './AddSmoochApp'
export default {

  name: 'SmoochApps',
  components: { AddApp },
  data () {
    return {
    	smoochApps: [],
    	headers: [
    	  { text: 'Name', value: 'name', align: 'left' },
    	  { text: 'Number', value: 'phone_number', align: 'left' },
    	  { text: 'Actions', value: '_id', align: 'right' },
    	],
    	AppsFormDialog: false,
    	appToDisconnect: null,
    	disconnectAppDialog: false,
    	appToEdit: null,
    	loaders: {
    		add: false,
    		apps: false,
    		disconnect: false
    	}
    }
  },
  mounted() {
  	this.init()
  	if(this.$route.query.cb && this.$route.query.cb === 'add') {
      this.handleAddAppClick()
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  methods: {
  	init() {
  		this.getApps()
  	},
  	getApps() {
  		if(!this.botId) {
  			return;
  		}
  		this.loaders.apps = true
  		this.$http_chat.get(`/bots/${this.botId}/apps/smooch/list`)
  			.then(res => {
  				this.smoochApps = res.data.smooch_apps.filter(e => e)
  				this.loaders.apps = false
  			})
  			.catch((err)=>{
  				const msg = err.response && err.response.data && err.response.data.message
  					?  err.response.data.message.error : true
  				this.$store.dispatch('setErrorMessage', msg);
  				this.loaders.apps = false
  			})
  	},
  	handleAddAppClick() {
  		this.appToEdit = null
  		this.AppsFormDialog = true;
  	},
  	handleAddAppSubmit() {
  		if(this.$refs.addApp) {
  			this.$refs.addApp.submit();
  		}
  	},
  	handleDisconnectAppClick(app) {
  		this.appToDisconnect = app
  		this.disconnectAppDialog = true
  	},
  	handleAddAppSuccess() {
  		this.AppsFormDialog = false;
  		this.appToEdit = null
  		this.getApps()
  	},
  	handleEditApp(item) {
  		this.appToEdit = item;
  		this.AppsFormDialog = true;
  	},
  	connectApp(app) {
  		this.loaders.disconnect = true
  		this.$http_chat.put(`/bots/${this.botId}/apps/smooch/connect`, 
  			this.$_.omit(app, ['tier_daily_consumed', 'status', '_id', 'integration_id', 'phone_number'])
  			)
  			.then(res => {
  				this.loaders.disconnect = false
  				this.getApps()
  			})
  			.catch((err)=>{
  				this.loaders.disconnect = false
  				const msg = err.response && err.response.data && err.response.data.message
  					?  err.response.data.message.error : true
  				this.$store.dispatch('setErrorMessage', msg);
  				this.loaders.disconnect = false
  			})
  	},
  	disconnectApp() {
  		const item = this.appToDisconnect
  		// console.log(item)
  		if(!this.botId) {
  			return;
  		}
  		this.loaders.disconnect = true
  		this.$http_chat.put(`/bots/${this.botId}/apps/smooch/${item.app_id}/disconnect`)
  			.then(res => {
  				this.appToDisconnect = null
  				this.disconnectAppDialog = false
  				this.getApps();
  				this.loaders.disconnect = false
  				// this.loaders.apps = false
  			})
  			.catch((err)=>{
  				const msg = err.response && err.response.data && err.response.data.message
  					?  err.response.data.message.error : true
  				this.$store.dispatch('setErrorMessage', msg);
  				this.loaders.disconnect = false
  			})
  	}
  }
}
</script>
<style lang="scss">
.campaigns-small-actions-btn {
	height: 24px;
	width: 24px;
	max-width: 24px;
	min-width: 24px;
	border-radius: 3px !important;
	margin-left: 2px;
}
.campain-small-action-icon {
	font-size: 16px !important;
	margin-left: 4px;
  color: #7F7F7F !important;
}
.campain-small-action-bot-icon {
	font-size: 16px !important;
}
.actions-col {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-right: 0 !important;
}
</style>